import classNames from 'classnames';
import React from 'react';

const AppTextLogo = props => {
  const style = props.style || 'light';

  return (
    <a href="https://madeby.studio" target="_blank" rel="noreferrer">
      <svg
        className="my-auto h-8 py-1"
        alt="Return to madeby.studio homepage"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 864 115.7633"
        aria-hidden="true"
      >
        <g id="full-rgb">
          {' '}
          <g>
            {' '}
            <path
              id="fullLogo"
              d="M0,91.1876V26.5157H10.3458v9.7h.13a18.7183,18.7183,0,0,1,4.7861-5.4314A25.9238,25.9238,0,0,1,31.6886,25.223a21.94,21.94,0,0,1,16.168,6.4656,22.5978,22.5978,0,0,1,4.5275,6.4676H53.03a26.5051,26.5051,0,0,1,5.4334-6.4676q7.4988-6.4656,18.4949-6.4656a22.0759,22.0759,0,0,1,17.2041,7.5018q6.7232,7.5016,6.7261,20.3066V91.1876H90.54V53.6788q0-9.0531-4.2038-13.9062a14.219,14.219,0,0,0-11.3188-4.8492,18.4252,18.4252,0,0,0-13.5806,5.9485,19.4864,19.4864,0,0,0-5.82,14.1V91.1876H45.2692V53.6788q0-9.0531-4.2039-13.9062a14.2174,14.2174,0,0,0-11.3168-4.8492,18.4217,18.4217,0,0,0-13.58,5.9485,19.48,19.48,0,0,0-5.8222,14.1V91.1876Z"
            ></path>{' '}
            <path
              id="fullLogo-2"
              data-name="fullLogo"
              d="M122.2289,82.8451q-9.056-9.6333-9.055-23.9934,0-14.3582,9.055-23.9934a29.0548,29.0548,0,0,1,21.9882-9.6353,28.1611,28.1611,0,0,1,13.7759,3.1045,24.3247,24.3247,0,0,1,8.2123,6.7242l1.1645,1.94h.13V26.5157h10.3458V91.1876H167.5V80.84h-.13l-1.1645,1.8118q-2.3269,3.49-8.0188,6.661A28.3717,28.3717,0,0,1,144.2171,92.48,29.0478,29.0478,0,0,1,122.2289,82.8451ZM129.7958,41.65q-6.2762,6.7261-6.2742,17.2022,0,10.477,6.2742,17.2021a21.7213,21.7213,0,0,0,31.43,0q6.2733-6.7231,6.2742-17.2021,0-10.4771-6.2742-17.2022a21.7215,21.7215,0,0,0-31.43,0Z"
            ></path>{' '}
            <path
              id="fullLogo-3"
              data-name="fullLogo"
              d="M199.832,82.8451q-9.0559-9.6333-9.055-23.9934,0-14.3582,9.055-23.9934A29.055,29.055,0,0,1,221.82,25.223a28.5352,28.5352,0,0,1,13.8391,3.1045q5.69,3.1026,8.1492,6.5959l1.1644,1.94h.13V.6474h10.3457v90.54H245.1032V80.84h-.13l-1.1644,1.8118q-2.3269,3.49-8.0189,6.661A28.3717,28.3717,0,0,1,221.82,92.48,29.048,29.048,0,0,1,199.832,82.8451ZM207.3989,41.65q-6.2762,6.7261-6.2741,17.2022,0,10.477,6.2741,17.2021a21.7214,21.7214,0,0,0,31.43,0q6.2731-6.7231,6.2742-17.2021,0-10.4771-6.2742-17.2022a21.7216,21.7216,0,0,0-31.43,0Z"
            ></path>{' '}
            <path
              id="fullLogo-4"
              data-name="fullLogo"
              d="M277.8259,82.91q-9.4437-9.5711-9.4438-24.0585,0-14.4855,9.4438-24.0586,9.438-9.5681,23.54-9.57,14.0977,0,23.5415,9.4418,9.4378,9.4439,9.4418,23.54v3.88H278.73A23.0407,23.0407,0,0,0,286.1034,76.96a21.7638,21.7638,0,0,0,15.262,5.82,24.5464,24.5464,0,0,0,16.4266-5.82,20.8032,20.8032,0,0,0,4.9163-5.82H333.054A32.88,32.88,0,0,1,301.3654,92.48Q287.2648,92.48,277.8259,82.91Zm1.1625-29.8788h44.3652a20.8972,20.8972,0,0,0-7.1129-12.87,21.6963,21.6963,0,0,0-14.8753-5.238,22.18,22.18,0,0,0-15.0035,5.238A21.2552,21.2552,0,0,0,278.9884,53.0314Z"
            ></path>{' '}
            <path
              id="fullLogo-5"
              data-name="fullLogo"
              d="M347.2839,91.1876V.6474H357.63V36.8635h.13l1.2928-1.94q2.2-3.3632,7.89-6.5327a28.3616,28.3616,0,0,1,13.9694-3.1677,29.0608,29.0608,0,0,1,21.9882,9.6353q9.0531,9.6362,9.055,23.9934,0,14.3582-9.055,23.9934A29.0538,29.0538,0,0,1,380.9126,92.48a28.74,28.74,0,0,1-14.0345-3.1677q-5.755-3.1677-7.8254-6.661L357.76,80.84h-.13V91.1876Zm16.62-49.5381q-6.2762,6.7261-6.2742,17.2022,0,10.477,6.2742,17.2021a21.7213,21.7213,0,0,0,31.43,0q6.2731-6.7231,6.2742-17.2021,0-10.4771-6.2742-17.2022a21.7215,21.7215,0,0,0-31.43,0Z"
            ></path>{' '}
            <path
              id="fullLogo-6"
              data-name="fullLogo"
              d="M418.42,26.5157h10.9931l14.2279,54.9715h9.7l16.8153-54.9715h10.9951l-27.1631,89.2476H442.9951l7.76-24.5757H435.88Z"
            ></path>{' '}
            <path
              id="fullLogo-7"
              data-name="fullLogo"
              className="fill-current text-primary"
              d="M482.0552,90.9291a8.1339,8.1339,0,1,1,5.5617,2.1986A7.53,7.53,0,0,1,482.0552,90.9291Z"
            ></path>{' '}
            <path
              id="fullLogo-8"
              data-name="fullLogo"
              d="M505.725,71.14h10.9931a17.358,17.358,0,0,0,3.7519,5.82q5.82,5.82,15.0035,5.82,8.2775,0,12.2227-2.7157a8.183,8.183,0,0,0,3.9453-6.9847,5.5918,5.5918,0,0,0-1.6164-4.01,13.6737,13.6737,0,0,0-5.238-2.9743q-3.6237-1.2908-6.4025-2.0052-2.7828-.7075-8.084-1.7467Q508.9588,57.95,508.9578,43.331q0-7.632,6.4676-12.87,6.4656-5.24,18.108-5.238,14.4855,0,22.8941,9.7a29.4979,29.4979,0,0,1,4.9144,9.7H550.3488a16.2282,16.2282,0,0,0-3.3631-4.7861q-4.9173-4.9143-13.4523-4.9143-6.8564,0-10.5411,2.5874t-3.6868,5.82a5.5727,5.5727,0,0,0,1.6164,4.0085,13.5924,13.5924,0,0,0,5.238,2.9762q3.6207,1.2937,6.4025,2.0033,2.78.7134,8.084,1.7466,21.3418,4.3992,21.3428,19.014,0,8.28-6.9847,13.8391-6.9836,5.5626-19.531,5.5617-15.7821,0-24.3171-10.6063A32.2815,32.2815,0,0,1,505.725,71.14Z"
            ></path>{' '}
            <path
              id="fullLogo-9"
              data-name="fullLogo"
              d="M569.1,36.2161v-9.7h8.4077V12.2878h10.3477V26.5157h20.6955v9.7H587.8556V81.4872h21.3429v9.7H577.5079V36.2161Z"
            ></path>{' '}
            <path
              id="fullLogo-10"
              data-name="fullLogo"
              d="M620.8389,64.6719V26.5157h10.3458V64.0246q0,9.3135,4.6578,14.0344t12.8049,4.721q8.9228,0,14.4864-5.8854,5.56-5.8824,5.5617-15.4555V26.5157h10.3478V91.1876H668.6955v-9.7h-.13a21.2046,21.2046,0,0,1-5.1729,5.5617A26.3635,26.3635,0,0,1,646.7073,92.48q-11.7708,0-18.8205-7.4367Q620.835,77.6071,620.8389,64.6719Z"
            ></path>{' '}
            <path
              id="fullLogo-11"
              data-name="fullLogo"
              d="M701.0315,82.8451q-9.0561-9.6333-9.055-23.9934,0-14.3582,9.055-23.9934A29.0547,29.0547,0,0,1,723.02,25.223a28.5352,28.5352,0,0,1,13.8391,3.1045q5.69,3.1026,8.1491,6.5959l1.1644,1.94h.13V.6474h10.3458v90.54H746.3026V80.84h-.13l-1.1644,1.8118q-2.327,3.49-8.0189,6.661A28.3713,28.3713,0,0,1,723.02,92.48,29.0477,29.0477,0,0,1,701.0315,82.8451ZM708.5984,41.65q-6.2761,6.7261-6.2742,17.2022,0,10.477,6.2742,17.2021a21.7213,21.7213,0,0,0,31.43,0q6.2731-6.7231,6.2742-17.2021,0-10.4771-6.2742-17.2022a21.7215,21.7215,0,0,0-31.43,0Z"
            ></path>{' '}
            <path
              id="fullLogo-12"
              data-name="fullLogo"
              d="M773.59,12.16a6.8651,6.8651,0,0,1-2.07-5.0446A6.8652,6.8652,0,0,1,773.59,2.07a7.1811,7.1811,0,0,1,10.0892,0,6.8713,6.8713,0,0,1,2.0684,5.0446,6.8711,6.8711,0,0,1-2.0684,5.0446,7.1858,7.1858,0,0,1-10.0892,0Zm-.1283,79.0281V26.5157h10.3458V91.1876Z"
            ></path>{' '}
            <path
              id="fullLogo-13"
              data-name="fullLogo"
              d="M806.3128,82.91q-9.5741-9.5711-9.5721-24.0585,0-14.4855,9.5721-24.0586,9.571-9.5681,24.0585-9.57,14.4825,0,24.0566,9.57Q863.9991,44.3672,864,58.8517,864,73.34,854.4279,82.91t-24.0566,9.57Q815.8829,92.48,806.3128,82.91ZM813.6863,41.65q-6.5988,6.7261-6.5979,17.2022t6.5979,17.2021a24.0576,24.0576,0,0,0,33.37,0q6.596-6.7231,6.5959-17.2021,0-10.4771-6.5959-17.2022a24.0579,24.0579,0,0,0-33.37,0Z"
            ></path>{' '}
          </g>{' '}
        </g>
      </svg>
      <span className="sr-only">madeby.studio Website</span>
    </a>
  );
};

export default AppTextLogo;
